import MuiContainedButton from './MuiContainedButton';

export default MuiContainedButton;
